/**
 * Validate if given input is a callable function
 */
const isFunction = (fn: any) => fn instanceof Function;
export default isFunction;
